var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{style:({
    background: _vm.$vuetify.theme.themes[_vm.theme].appBackground,
    color: _vm.$vuetify.theme.themes[_vm.theme].onBackground
})},[_c('system-bar'),(_vm.showMenu)?_c('cross-menu'):_vm._e(),_c('v-main',[_c('v-container',{staticClass:"pa-0 h-100",attrs:{"fluid":""}},[_c('router-view'),_c('modals')],1)],1),_c('app-update-notification-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }